var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white m-3 rounded-md pb-5"},[_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.employeeData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }